/**
 * TEMP: This is a hard-coded list of marketing trip boards. This will be a simple,
 * static list in source control until we understand usage patterns and the
 * need for a more developed system.
 *
 * GENERATION
 * To generate pieces of this list, obtain a text file containing trip board URLs for which they want to promote
 * and run the following bash script:
 *
 * grep tripboard marketing-trip-boards.txt | awk -F/ '{print "'\''" $NF "'\'': true,"}' | sort -n | uniq
 *
 * Copy the results in to the bottom of the list and release this project into production
 *
 * @todo deprecate once graphql returns marketing flag
 */
export default {
    '92cfae78-5e06-11e8-9c2d-fa7ae01bbebc': true,
    '125171c8-d7e1-4f3d-89e9-42707a6751d8': true,
    '614b83f4-2647-4d48-a1c9-3e9acc8826a4': true,
    '69a364a5-d4df-46b7-a238-f6e76c26e60a': true,
    '8f4c9f58-8623-4105-b91b-16fc7007cd7c': true,
    '9804d28a-d8b9-4e95-83a0-349b93a1ad86': true,
    'e3c04f49-d508-41c7-8208-958c48fd35eb': true,
    '659755e4-52e8-4bd0-848f-b8792b03cf70': true,
    '733a42c5-8b7b-4f3c-b1ff-0482c2d754d3': true,
    '5a8cb4b9-b834-48eb-a17f-a051f1f647b7': true,
    'fcbe4db2-b7e8-45cd-ac4f-8b804d259969': true,
    '9f2e1b85-7035-4843-bd1a-b11cdd0a242b': true,
    '65d6d52d-1c7f-4972-9e02-5ae8bf175452': true,
    '56b00749-e2f0-44b8-a3e6-47f8dfbc8c94': true,
    '9fe7bef9-52ee-4b50-9a1e-8affec321698': true,
    'f4d86139-0d82-458e-b3ab-a88e0a72da82': true,
    'ab779a91-264e-4e46-af05-5b201aa3a0ac': true,
    '98198f94-dcbb-4708-9f49-9ba31514a5e0': true,
    'b7c3c3da-6e3b-422c-8773-9babe17c98fe': true,
    'fd4b2d3f-0a38-4cd0-a8ef-ae8fb6608a21': true,
    'c12ca6c7-d8bc-40fb-b9ec-5503df8dd7c5': true,
    'a59d14cc-927d-4a2a-ad44-1d248630594b': true,
    'e935153c-92a0-4b9d-b9ee-41476520cd87': true,
    '6fff96a4-c138-47c0-8e17-fafcce8d5de9': true,
    'd94958f7-7607-4b50-937b-6486c11df94b': true,
    'c2ee7802-cd38-412a-b1fc-222abc814a27': true,
    '2ff83b08-892a-40c5-8c7f-ba3c1ae80b86': true,
    'b6012ea9-85ed-41f1-a983-5d64c7e6a89a': true,
    'ee038b13-f448-41cd-b85b-7ea277ed01f2': true,
    '695edd8f-88a7-422f-ac5d-fa46bb9bf81d': true,
    'a2938dab-2055-4d82-a802-dae9f984d73b': true,
    '426d185e-8f70-4e40-988f-4ebdfbac18d8': true,
    '2321d3be-1e5d-4064-8382-fda2ba768967': true,
    'babcfb00-f5be-4d66-9749-33e39e5a42ca': true,
    '28e58165-8194-4e7c-ba0c-e13d5236e390': true,
    '0b320e01-c9e5-4933-a96e-9d262d23670d': true,
    '1b03c7d8-985d-4c1c-8739-6f479615b162': true,
    '725709fd-5404-4784-9031-13ecfebfad72': true,
    'ac740145-0be2-4a6a-9eec-fb309ba6c7b6': true,
    '1724d366-fbba-4640-a28a-ed844072732a': true,
    'ac0b4ee2-9106-4a9b-bf39-fd5d3d0956d6': true,
    'ddcfaded-ab5e-4916-a5c6-3e0628382467': true,
    '6f7a187f-5dfb-4ff7-894f-09e0e886203a': true,
    'c81f110d-6070-4f4b-8262-d068c9bb35d8': true,
    '0bf88e83-31eb-4852-b948-f54bd38c299a': true,
    '0b077483-776a-4000-a728-a14b83562cd6': true,
    '4a76e119-8186-41c1-9285-3bd8c181ae9c': true,
    '030d6dd8-4933-4e49-acb0-267dae95ea21': true,
    'c5f63525-0606-4f2c-91a4-f1aec650c3a5': true,
    '8504fb2a-935e-48c4-83e1-1a6696c49f4d': true,
    '5792cd5e-f453-439c-8d4c-aa5b33ee52de': true,
    '29362f18-ec56-4ab1-854b-51eeae313731': true,
    '76c3337d-4ddf-476f-83c5-47533c9dd05d': true,
    '3860fab1-93f9-4b34-a2f0-a2c5dbfc08dd': true,
    '7d82f525-10e3-43a9-a601-774028fe6cc5': true,
    'd93a30fc-6ab1-4329-aa6e-44351463bbc3': true,
    '382e78bc-bc28-4b66-8d8a-b787e4b32fa3':true,
    '4a7adccd-0a7a-4e40-a235-00557c5ac9ca':true,
    '22ef9560-d21d-49b0-b2da-2530f3f48feb':true,
    '665c23cf-0b9e-4581-bc34-6e8b42d782f9':true,
    '280ecb13-040d-4ac2-9d9a-be78c0acaf55':true,
    '4554c855-6eec-4c88-90c4-4b9d8b5d51df':true,
    '152ae21c-7453-449f-b6df-a812de4bed45':true,
    '6295cacb-bd39-4ad5-b0b4-5f3b4c650f04':true,
    'c9709f7a-b7c7-4e5c-a9f6-abe78e68fae3':true,
    '92d2a7f0-4c38-42c1-898e-09ab6acfbf6e':true,
    'afbe6aeb-cb86-446f-9d37-820de0bf0fc0':true,
    'ab066ca5-aed3-4fc2-88d1-40cd16bd5d0c':true,
    '1198f29d-bd39-46af-b729-88e481d4999d':true
};



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/marketing-tripboards.js